import useModuleFilters from '../../../shared/data/useModuleFilters';
import FilterBar from '../../../shared/components/patterns/FilterBar';
import { tenantFormSchema } from '../adminFilter.schemas';
import IconActions from '../../../shared/components/IconActions';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getRoutePath, ROUTE_IDS } from '@/app/router/route-registry';
import { listAdminTenants } from '@/modules/admin/services/admin-tenants.service';

function buildClientDetailPath(tenantId) {
  const routeId = ROUTE_IDS.ADMIN_CONTROL_PLANE_CLIENT_DETAIL;
  const pathTemplate = (routeId ? getRoutePath(routeId) : null) || '/admin/clients/:tenantId';
  return pathTemplate.replace(':tenantId', tenantId);
}

export default function AdminControlPlaneClientsPage() {
  const [tenants, setTenants] = useState([]);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let active = true;

    async function load() {
      const result = await listAdminTenants();
      if (!active) {
        return;
      }

      if (!result.ok) {
        setError(result.message);
        setTenants([]);
        setIsLoading(false);
        return;
      }

      setTenants(result.data.tenants.filter((tenant) => !tenant.isPlatformRoot));
      setError('');
      setIsLoading(false);
    }

    load();

    return () => {
      active = false;
    };
  }, []);

  const moduleFilters = useModuleFilters({ schema: tenantFormSchema, rows: tenants });
  const filteredRows = moduleFilters.filterRows(tenants);

  return (
    <section className="control-plane-page">
      <header className="control-plane-topbar">
        <div>
          <div className="control-plane-topbar__title">Clienti</div>
          <div className="control-plane-topbar__subtitle">
            Vista control plane derivata dai tenant reali senza metriche billing inventate
          </div>
        </div>
      </header>

      <div className="control-plane-content">
        <section className="control-plane-metrics control-plane-metrics--3">
          <article className="control-plane-metric">
            <div className="control-plane-metric__label">Clienti attivi</div>
            <div className="control-plane-metric__value">{tenants.filter((tenant) => tenant.active).length}</div>
            <div className="control-plane-metric__support">Tenant commercialmente attivi</div>
          </article>
          <article className="control-plane-metric">
            <div className="control-plane-metric__label">Clienti inattivi</div>
            <div className="control-plane-metric__value">{tenants.filter((tenant) => !tenant.active).length}</div>
            <div className="control-plane-metric__support">Tenant sospesi o disattivati</div>
          </article>
          <article className="control-plane-metric">
            <div className="control-plane-metric__label">MRR</div>
            <div className="control-plane-metric__value">—</div>
            <div className="control-plane-metric__support">backend non ancora collegato</div>
          </article>
        </section>
        <FilterBar model={moduleFilters} />


        {isLoading ? <div className="control-plane-empty-state">Caricamento clienti control plane...</div> : null}
        {!isLoading && error ? <div role="alert" className="control-plane-inline-error wt-inline-error">{error}</div> : null}
        {!isLoading && !error && tenants.length === 0 ? (
          <div className="control-plane-empty-state">Nessun cliente reale disponibile.</div>
        ) : null}
        {!isLoading && !error && tenants.length > 0 ? (
          <section className="control-plane-clients-grid">
            {filteredRows.map((tenant) => (
              <article key={tenant.id} className="control-plane-client-card">
                <div className="control-plane-client-card__title">{tenant.name}</div>
                <div className="control-plane-client-card__meta">{tenant.slug || tenant.id}</div>
                <div className="control-plane-badge-row" style={{ marginTop: '12px' }}>
                  <span className="control-plane-badge">{tenant.planCode || 'standard'}</span>
                  <span className={tenant.active ? 'control-plane-badge is-success' : 'control-plane-badge is-danger'}>
                    {tenant.active ? 'Attivo' : 'Disattivo'}
                  </span>
                </div>
                <div className="control-plane-client-card__meta" style={{ marginTop: '12px' }}>
                  Moduli: {tenant.enabledModuleKeys.join(', ') || '—'}
                </div>
                <div className="control-plane-client-card__meta">Utenti: {Number.isFinite(tenant.userCount) ? tenant.userCount : '—'}</div>
                <div className="control-plane-client-card__meta">Spesa mensile: —</div>
                <div className="control-plane-client-card__meta">Automazioni: —</div>
                <div className="control-plane-client-card__footer"><IconActions>
                  <span className="control-plane-table__muted">{tenant.provisioningStatus || 'Non disponibile'}</span>
                  <Link className="control-plane-action-button" to={buildClientDetailPath(tenant.id)}>
                    Scheda cliente
                  </Link>
                </IconActions></div>
              </article>
            ))}
          </section>
        ) : null}
      </div>
    </section>
  );
}
